export default "__VITE_ASSET__D78h4ot2__"